import React, { FC, Fragment, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import { dexisStatusVar } from 'apollo/reactive-variables/scan-case';
import { Alert, Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from 'config/constants';
import { dexisStatusTemplate } from 'apollo/templates/scanner-case';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { ScannerCaseAuthStatus } from 'models/scanner-case';

const DexisAuthContainer: FC = () => {
    const { t: translate } = useTranslation(['scan-cases']);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dexisAuthUrl, setDexisAuthUrl] = useState('');
    const dexisFrontendStatus = dexisStatusVar();
    const { showBoundary } = useDenthubErrorBoundary();
    const isCurrentlyAuthorizing = window.location.href.includes('dexis-auth-callback');

    useQuery(dexisStatusTemplate, {
        onCompleted: ({ dexisStatus }: { dexisStatus: ScannerCaseAuthStatus }) => {
            dexisStatusVar(dexisStatus);
            if (dexisStatus.enabled && !dexisStatus.authorized && !isCurrentlyAuthorizing) {
                setDialogOpen(true);
                setDexisAuthUrl(
                    `${CONSTANTS.DEXIS_AUTH_URL}/B2C_1A_SIGNUP_SIGNIN/oauth2/v2.0/authorize?client_id=${dexisStatus.clientId}&response_type=code&scope=offline_access%20https://envistab2c.onmicrosoft.com/ConnectPublicApi/User.Standard&redirect_uri=${CONSTANTS.DEXIS_AUTH_REDIRECT}&response_mode=query&prompt=login`,
                );
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const onDialogClose = () => {
        setDialogOpen(false);
    };

    return (
        <Fragment>
            {dexisFrontendStatus.enabled ? (
                <DHDialog
                    fullWidth
                    maxWidth="sm"
                    open={dialogOpen}
                    onClose={onDialogClose}
                    title={translate('scan-cases:YOU_NEED_TO_LOGIN_TO_DEXIS')}
                >
                    <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                        {translate('scan-cases:DEXIS_LOGIN_DESC')}
                    </Alert>
                    <Box mt={2} sx={{ textAlign: 'center' }}>
                        <Button variant="contained" href={dexisAuthUrl}>
                            {translate('scan-cases:LOGIN_TO_DEXIS')}
                        </Button>
                    </Box>
                </DHDialog>
            ) : undefined}
        </Fragment>
    );
};

export default DexisAuthContainer;
